// ================= LANGIT & CUACA HIDUP (F5) =================
// Keyframes langit per jam: [jam, rgb atas, rgb bawah, kegelapan 0..1]
// Transisi fajar/senja terjadi otomatis lewat interpolasi antar keyframe.
const SKY_KEYS = [
  [0,    [10, 14, 36],   [26, 32, 60],    1],    // malam
  [4.5,  [10, 14, 36],   [26, 32, 60],    1],
  [6,    [96, 110, 152], [242, 188, 142], 0.55], // fajar
  [7.5,  [191, 227, 240],[232, 244, 224], 0],    // pagi
  [16.5, [176, 216, 240],[232, 244, 224], 0],    // sore
  [18,   [88, 100, 164], [242, 158, 102], 0.45], // senja
  [19.5, [10, 14, 36],   [26, 32, 60],    1],
  [24,   [10, 14, 36],   [26, 32, 60],    1],
];

export function lerp3(a, b, t) {
  return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
}

export function skyAt(h) {
  for (let i = 0; i < SKY_KEYS.length - 1; i++) {
    const A = SKY_KEYS[i], B = SKY_KEYS[i + 1];
    if (h >= A[0] && h <= B[0]) {
      const t = (h - A[0]) / (B[0] - A[0]);
      return { top: lerp3(A[1], B[1], t), bot: lerp3(A[2], B[2], t), dark: A[3] + (B[3] - A[3]) * t };
    }
  }
  return { top: SKY_KEYS[0][1], bot: SKY_KEYS[0][2], dark: SKY_KEYS[0][3] };
}

// hash deterministik → [0,1) — untuk tekstur rumput, tebing, bintang, cuaca
export function hashN(n) {
  const x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
  return x - Math.floor(x);
}

// Jam nyata Jawsel (WIB / Asia/Jakarta) sebagai desimal 0..24 — sumber "mode malam otomatis" peta publik, homepage & Alun-alun,
// sehingga semua pengunjung melihat langit yang sama apa pun zona waktu perangkatnya.
const WIB_FMT = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Jakarta", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
export function jamWIB(d = new Date()) {
  const p = {};
  for (const { type, value } of WIB_FMT.formatToParts(d)) p[type] = +value;
  return ((p.hour || 0) % 24) + (p.minute || 0) / 60 + (p.second || 0) / 3600;
}

// 0 = siang penuh → 1 = malam penuh dari jam WIB (senja 17–19, fajar 4.5–6) — untuk kaca UI & overlay malam Alun-alun
export const malamDari = h => (h >= 19 || h < 4.5 ? 1 : h >= 17 ? (h - 17) / 2 : h < 6 ? 1 - (h - 4.5) / 1.5 : 0);
